import { css } from "styled-components";

// 위치
export const getPositionStyle = (position) => {
  switch (position) {
    case "right":
      return css`
        width: 100%;
        justify-content: end;
      `;
    case "center":
      return css`
        justify-content: center;
      `;
    case "row":
      return css`
        flex-direction: row;
      `;
    case "column":
      return css`
        flex-direction: column;
      `;
    case "space-between":
      return css`
        justify-content: space-between;
      `;
    default:
      return css``;
  }
};

export const getIconPositionStyle = (position) => {
  switch (position) {
    case "right":
      return css`
        flex-direction: row-reverse;
      `;
    default:
      return css`
        flex-direction: row;
      `;
  }
};

/**
 * @desc 화살표 방향에 따른 스타일 설정
 * @param {string} arrow - 화살표 방향
 * @returns {CSS} 화살표 방향에 따른 CSS 스타일
 */
export const getArrowPositionStyle = (arrow) => {
  switch (arrow) {
    case "top":
      return css`
        bottom: 110%;
        left: 50%;
        transform: translateX(-50%);
        &::before {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 7px;
          border-style: solid;
          border-color: ${({ theme }) => theme.color.gray200 || theme.color.gray200}
            transparent transparent transparent;
          width: 0;
          height: 0;
        }

        &::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: ${({ theme }) => theme.color.white} transparent
            transparent transparent;
          width: 0;
          height: 0;
        }
      `;
    case "bottom":
      return css`
        // top: 110%;
        top: 90%;
        left: 50%;
        transform: translateX(-50%);
        &::before {
          content: "";
          position: absolute;
          // top: -55%;
          top: -20%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 7px; /* 테두리 두께 */
          border-style: solid;
          border-color: transparent transparent
            ${({ theme }) => theme.color.gray200 || theme.color.gray200} transparent; /* 수정: 아래쪽으로 향하는 화살표 색상 */
          width: 0;
          height: 0;
        }

        &::after {
          content: "";
          position: absolute;
          // top: -50%;
          top: -17%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 6px; /* 삼각형 크기 */
          border-style: solid;
          border-color: transparent transparent
            ${({ theme }) => theme.color.white} transparent; /* 수정: 아래쪽으로 향하는 화살표 색상 */
          width: 0;
          height: 0;
        }
      `;
    case "left":
      return css`
        right: 110%;
        top: 50%;
        transform: translateY(-50%);
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 100%;
          transform: translateY(-50%);
          border-width: 7px;
          border-style: solid;
          border-color: transparent transparent transparent
            ${({ theme }) => theme.color.gray200 || theme.color.gray200};
          width: 0;
          height: 0;
        }

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 100%;
          transform: translateY(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: transparent transparent transparent
            ${({ theme }) => theme.color.white};
          width: 0;
          height: 0;
        }
      `;
    case "right":
    default:
      return css`
        left: 110%;
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          right: 100%;
          transform: translateY(-50%);
          border-width: 7px;
          border-style: solid;
          border-color: transparent
            ${({ theme }) => theme.color.gray200 || theme.color.gray200} transparent
            transparent;
          width: 0;
          height: 0;
        }

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 100%;
          transform: translateY(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: transparent ${({ theme }) => theme.color.white}
            transparent transparent;
          width: 0;
          height: 0;
        }
      `;
  }
};
